import { useQuery } from '@tanstack/react-query';
import { getEmailByOobcode } from 'shared/services/backend-api';
import { ResetPasswordErrorTypes } from 'shared/types/reset-password-form';

export const queryKey = 'reset-link';

export type ResetLinkLookup = {
  email: string | null;
  isDeadLink: boolean;
};

// Only a dead link may replace the form: the email is display-only, and the lookup reports everything else itself.
export const resolveResetLink = async (
  oobCode: string,
): Promise<ResetLinkLookup> => {
  try {
    return { email: await getEmailByOobcode(oobCode), isDeadLink: false };
  } catch (error) {
    return {
      email: null,
      isDeadLink: error === ResetPasswordErrorTypes.InvalidCode,
    };
  }
};

export const useResetLinkQuery = (oobCode?: string) =>
  useQuery({
    queryKey: [queryKey, oobCode],
    queryFn: () => (oobCode ? resolveResetLink(oobCode) : null),
    enabled: !!oobCode,
  });
